import { system } from 'styled-system'

import type { Config, ResponsiveValue } from '../styled-system-re-exported-types'

type PropsWithMinColumnWidth = {
    /**
     * Sets minimum width of each column. It splits horizontal space between maximum number of columns, that is possible for provided minimum column width.
     * When remaining space is not enough to fit another column, it expands  each column width, so that they take up any available space.
     * Cannot be used in conjunction with 'columnsCount' prop. They use the same CSS property - gridTemplateColumns.
     */
    minColumnWidth?: ResponsiveValue<number>
    columnsCount?: never
}

type PropsWithColumns = {
    /**
     * Splits horizontal space between provided number of columns. Every column gets equal width.
     * Cannot be used in conjunction with 'minColumnWidth' prop. They use the same CSS property - gridTemplateColumns.
     */
    columnsCount?: ResponsiveValue<number>
    minColumnWidth?: never
}

export type GridCustomProps = PropsWithMinColumnWidth | PropsWithColumns

/** @public used in docs */
const gridConfig = {
    columnsCount: {
        property: 'gridTemplateColumns',
        transform: (value) => `repeat(${value}, 1fr)`,
    },
    minColumnWidth: {
        property: 'gridTemplateColumns',
        transform: (value) => `repeat(auto-fit, minmax(${value}px, 1fr))`,
    },
} as const satisfies Config<keyof GridCustomProps>

export const gridCustom = system(gridConfig)
